import { render, staticRenderFns } from "./gs-address-display.vue?vue&type=template&id=421020bc"
import script from "./gs-address-display.vue?vue&type=script&lang=ts"
export * from "./gs-address-display.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports